import { _ as _sfc_main } from "./VaNavbar.vue_vue_type_script_lang-dfc7c443.mjs";
import { openBlock, createElementBlock, normalizeStyle, createElementVNode, renderSlot, createCommentVNode } from "vue";
import { _ as _export_sfc } from "../../../plugin-vue_export-helper-cc2b3d55.mjs";
const VaNavbar_vue_vue_type_style_index_0_lang = "";
const _hoisted_1 = { class: "va-navbar__left" };
const _hoisted_2 = { class: "va-navbar__center" };
const _hoisted_3 = { class: "va-navbar__right" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("header", {
    ref: "scrollRoot",
    class: "va-navbar",
    style: normalizeStyle(_ctx.computedStyle)
  }, [
    createElementVNode("div", _hoisted_1, [
      renderSlot(_ctx.$slots, "left")
    ]),
    createElementVNode("div", _hoisted_2, [
      renderSlot(_ctx.$slots, "default")
    ]),
    createElementVNode("div", _hoisted_3, [
      renderSlot(_ctx.$slots, "right")
    ]),
    _ctx.shape ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: "va-navbar__background-shape",
      style: normalizeStyle(_ctx.shapeStyleComputed)
    }, null, 4)) : createCommentVNode("", true)
  ], 4);
}
const _VaNavbar = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  _VaNavbar as _
};
//# sourceMappingURL=VaNavbar-7ebbeb69.mjs.map
